import React from 'react';

import { Container, FlexDiv } from 'commonStyles';

import Card from './Card';
import { CardContainer } from './CardSectionStyle';

const CardSection = ({ cardData = {}, scollToRef }) => {
	const { cards } = cardData;
	return (
		<CardContainer ref={scollToRef} $bg='#F5F5F5' top_P='24'>
			<Container>
				{cards?.length > 0 &&
					<FlexDiv wrap='wrap' top_M='15'>
						{cards.map((card) => <Card key={card.heading} {...card} />)}
					</FlexDiv>}
			</Container>
		</CardContainer>
	);
};

export default CardSection;
